(function(_){
    'use strict';
    _['ESHOP.KEY']='eShop';
    _['ESHOP.NO-CONTENT'] = 'This module is empty';
    _['ESHOP.NO-PRODUCTS']='There is no product with selected criteria';
    _['PRODUCTS.PRODUCT.TOCART.CONFIRM'] = 'Add to cart';
}(translations['en']));












// WEBPACK FOOTER //
// ./src/app/modules/eshop/lang/eshop-lang_en.js